<template>
  <div v-if="paragraphs.length > 0" class="mb-6">
    <div
      v-for="(paragraph, index) in paragraphs"
      :key="index"
      class="paragraph-1 text-blue-1 mb-4">
      <div v-html="paragraph" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  paragraphs: string[]
}

defineProps<Props>()
</script>